export default __webpack_public_path__ + "static/media/lightbulb_icon.174fabfc.svg";